import PropTypes from 'prop-types';

import { usePermission } from 'src/hooks/usePermission';

const PermissionGuard = ({
  permission,
  role,
  mode = 'OR',
  children,
  fallback = null,
}) => {
  const { can } = usePermission();

  const isAllowed = can({
    permission,
    role,
    mode,
  });

  if (isAllowed) {
    return children;
  }

  return fallback;
};

PermissionGuard.propTypes = {
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  role: PropTypes.string,
  mode: PropTypes.oneOf(['AND', 'OR']),
  children: PropTypes.node,
  fallback: PropTypes.node,
};

export default PermissionGuard;
